import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import validSupergitHIS from "../../api/validSupergitHIS";
import toast from "react-hot-toast";

export const getVendors = createAsyncThunk(
  "getVendors",
  async (_, { rejectWithValue }) => {
    try {
      const response = await validSupergitHIS.post("getvendors");
      return response?.data?.data;
    } catch (error) {
      toast.error(error?.response?.data?.error || "something went wrong");
      return rejectWithValue(
        error?.response?.data?.error || "something went wrong"
      );
    }
  }
);

export const getVendorList = createAsyncThunk(
  "getVendorList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await validSupergitHIS.post("list_vendor", data);
      return response.data;
    } catch (error) {
      toast.error(error?.response?.data?.error || "something went wrong");
      return rejectWithValue(
        error?.response?.data?.error || "something went wrong"
      );
    }
  }
);

export const CreateNewVendor = createAsyncThunk(
  "CreateNewVendor",
  async (data, { rejectWithValue }) => {
    try {
      const response = await validSupergitHIS.post("vendor", data);
      return response.data;
    } catch (error) {
      toast.error(error?.response?.data?.error || "something went wrong");
      return rejectWithValue(
        error?.response?.data?.error || "something went wrong"
      );
    }
  }
);

export const getPurchasedEntryList = createAsyncThunk(
  "getPurchasedEntryList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await validSupergitHIS.post(
        "list_purchased_entry",
        data
      );
      return response.data;
    } catch (error) {
      toast.error(error?.response?.data?.error || "something went wrong");
      return rejectWithValue(
        error?.response?.data?.error || "something went wrong"
      );
    }
  }
);

export const CreateNewPurchasedEntry = createAsyncThunk(
  "CreateNewPurchasedEntry",
  async (data, { rejectWithValue }) => {
    try {
      const response = await validSupergitHIS.post("purchased_entry", data);
      return response.data;
    } catch (error) {
      toast.error(error?.response?.data?.error || "something went wrong");
      return rejectWithValue(
        error?.response?.data?.error || "something went wrong"
      );
    }
  }
);
export const CreateNewPurchasedPayment = createAsyncThunk(
  "CreateNewPurchasedPayment",
  async (data, { rejectWithValue }) => {
    try {
      const response = await validSupergitHIS.post("purchased_payment", data);
      return response.data;
    } catch (error) {
      toast.error(error?.response?.data?.error || "something went wrong");
      return rejectWithValue(
        error?.response?.data?.error || "something went wrong"
      );
    }
  }
);



// getSearchedVendor removed


export const getSearchedPurchaseEntery = createAsyncThunk(
  "getSearchedPurchaseEntery",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await validSupergitHIS.post("searchPurchasedEntry", payload);
      return response.data;
    } catch (error) {
      toast.error(error?.response?.data?.error || "something went wrong");
      return rejectWithValue(
        error?.response?.data?.error || "something went wrong"
      );
    }
  }
);


export const updateVendor = createAsyncThunk(
  "updateVendor",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await validSupergitHIS.put(`vendor/${id}`, data);
      return response.data;
    } catch (error) {
      toast.error(error?.response?.data?.error || "something went wrong");
      return rejectWithValue(
        error?.response?.data?.error || "something went wrong"
      );
    }
  }
);


export const deleteVendor = createAsyncThunk(
  "deleteVendor",
  async (id, { rejectWithValue }) => {
    try {
      const response = await validSupergitHIS.delete(`vendor/${id}`);
      return response.data;
    } catch (error) {
      toast.error(error?.response?.data?.error || "something went wrong");
      return rejectWithValue(
        error?.response?.data?.error || "something went wrong"
      );
    }
  }
);


export const updatePurchasedEntry = createAsyncThunk(
  "updatePurchasedEntry",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await validSupergitHIS.put(`purchased_entry/${id}`, data);
      return response.data;
    } catch (error) {
      toast.error(error?.response?.data?.error || "something went wrong");
      return rejectWithValue(
        error?.response?.data?.error || "something went wrong"
      );
    }
  }
);


export const deletePurchasedEntry = createAsyncThunk(
  "deletePurchasedEntry",
  async (id, { rejectWithValue }) => {
    try {
      const response = await validSupergitHIS.delete(`purchased_entry/${id}`);
      return response.data;
    } catch (error) {
      toast.error(error?.response?.data?.error || "something went wrong");
      return rejectWithValue(
        error?.response?.data?.error || "something went wrong"
      );
    }
  }
);


const initialState = {
  vendors: {},
  isLoading: false,
  vendorList: null,
  purchasedEntryList: null,
};

const PurchaseSlice = createSlice({
  name: "purchase",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getVendors.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getVendors.fulfilled, (state, action) => {
        state.vendors = action.payload;
        state.isLoading = false;
      })
      .addCase(getVendors.rejected, (state) => {
        state.isLoading = false;
      })

      .addCase(getVendorList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getVendorList.fulfilled, (state, action) => {
        state.vendorList = action.payload;
        state.isLoading = false;
      })
      .addCase(getVendorList.rejected, (state) => {
        state.isLoading = false;
      })

      .addCase(getPurchasedEntryList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getPurchasedEntryList.fulfilled, (state, action) => {
        state.purchasedEntryList = action.payload;
        state.isLoading = false;
      })
      .addCase(getPurchasedEntryList.rejected, (state) => {
        state.isLoading = false;
      })

      .addCase(CreateNewVendor.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(CreateNewVendor.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(CreateNewVendor.rejected, (state) => {
        state.isLoading = false;
      })

      .addCase(CreateNewPurchasedEntry.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(CreateNewPurchasedEntry.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(CreateNewPurchasedEntry.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(CreateNewPurchasedPayment.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(CreateNewPurchasedPayment.fulfilled, (state, action) => {
        state.isLoading = false;
        toast.success(action?.payload?.message);
      })
      .addCase(CreateNewPurchasedPayment.rejected, (state) => {
        state.isLoading = false;
      })



      // getSearchedVendor extraReducers removed


      .addCase(getSearchedPurchaseEntery.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getSearchedPurchaseEntery.fulfilled, (state, action) => {
        state.isLoading = false;
        state.purchasedEntryList = action.payload;
      })
      .addCase(getSearchedPurchaseEntery.rejected, (state) => {
        state.isLoading = false;
      })

      .addCase(updateVendor.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateVendor.fulfilled, (state, action) => {
        state.isLoading = false;
        toast.success(action?.payload?.message || "Vendor updated successfully");
      })
      .addCase(updateVendor.rejected, (state) => {
        state.isLoading = false;
      })

      .addCase(deleteVendor.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteVendor.fulfilled, (state, action) => {
        state.isLoading = false;
        toast.success(action?.payload?.message || "Vendor deleted successfully");
      })
      .addCase(deleteVendor.rejected, (state) => {
        state.isLoading = false;
      })

      .addCase(updatePurchasedEntry.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updatePurchasedEntry.fulfilled, (state, action) => {
        state.isLoading = false;
        toast.success(action?.payload?.message || "Purchased Entry updated successfully");
      })
      .addCase(updatePurchasedEntry.rejected, (state) => {
        state.isLoading = false;
      })

      .addCase(deletePurchasedEntry.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deletePurchasedEntry.fulfilled, (state, action) => {
        state.isLoading = false;
        toast.success(action?.payload?.message || "Purchased Entry deleted successfully");
      })
      .addCase(deletePurchasedEntry.rejected, (state) => {
        state.isLoading = false;
      });
  },
});

export default PurchaseSlice.reducer;
